module.exports = __webpack_public_path__ + "img/brasil.5f5901e4.png";